/** Response L2/L3 panes Soft≠Live — prepare/equipment/rules rehomed via route-mask aliases. */
import { html, F, Alert } from "./ui.js";
import { Cell as CellFloat } from "./response-cell.js";
import { CasesDesk } from "./cases-desk.js";
import { RobotsDesk } from "./external-fleet-desk.js";

/** @deprecated Prefer response-cell.js — kept for hash triage imports. */
export function Cell({ toast }) {
  return html`<${CellFloat} toast=${toast}/>`;
}

export function CasesPane({ toast }){
  return html`<${CasesDesk} toast=${toast}/>`;
}

export function RobotsPane({ toast }){
  return html`
    <${F} data-cmc-residual="page192-robots">
      <${Alert} tone="info" title="Robots and SEB"
        say="External fleet catalogue and command intents for drones and ground units."/>
      <${RobotsDesk} toast=${toast}/>
    <//>`;
}

/* Demounted Soft≠ invent Soft disappear:
 * AutomationsPane → /automations
 * Drill/Readiness/Sop → /prepare/*
 * Equipment → /ops/resources?type=equipment
 * Rules → /automations/legacy-rules
 */
